import type {SkeletonProps} from '@gwc/core'
import {Skeleton} from '@gwc/core'
import clsx from 'clsx'
import React, {memo} from 'react'

import * as classes from './Badge.classes'

type BadgeSkeletonProps = SkeletonProps & {
  badgeSize?: 's' | 'm' | 'l'
}

export const BadgeSkeleton = memo(
  ({badgeSize = 'm', ...props}: BadgeSkeletonProps): React.ReactElement => (
    <Skeleton className={clsx(classes.badge, classes.badgeSize[badgeSize])} {...props} />
  ),
)
